// import { useAxios } from '@/hooks/web/useAxios'
import request from '@/config/axios'
// const request = useAxios()
// const AUTH_PREFIX = '/auth/api/v1'
const AUTH_PREFIX = '/api-parts/api/v1.0/auth'
const ORG = '/org'
const ACCOUNT = '/account'
const ROLE = '/role'
const SERVICE = '/service'
const RESOURCE = '/resource'
// 获取当前登录账号权限
export const refreshToken = () => {
  return request.get({
    baseUrl:'m2i',
    url: 'auth/refreshtoken'
  })
}
export const getOrg = (name) => {
  return request.get({
    url: `${AUTH_PREFIX}${ORG}?index=0&count=1000&name=${name}&includeAdmin=true`
  })
}
// export const createOrg = (data) => {
//   return request.post({
//     url: `${AUTH_PREFIX}${ORG}`,
//     data
//   })
// }
// export const updateOrg = (data) => {
//   return request.put({
//     url: `${AUTH_PREFIX}${ORG}`,
//     data
//   })
// }
// export const deleteOrg = (id) => {
//   return request.delete({
//     url: `${AUTH_PREFIX}${ORG}/byid?id=${id}`
//   })
// }

// // 获取组织详情，主要是获取服务
// export const getOrgById = (id) => {
//   return request.get({
//     url: `${AUTH_PREFIX}${ORG}/byid?id=${id}`
//   })
// }

// // 获取所有服务
// export const getServiceList = (type) => {
//   return request.get({
//     url: `${AUTH_PREFIX}/service?queryType=${type}&index=0&count=1000`
//   })
// }
// // 给org配置可用服务
// export const configOrgService = (data) => {
//   return request.post({
//     url: `${AUTH_PREFIX}${ORG}/service`,
//     data
//   })
// }

// 获取当前登录账号权限
export const getAccountMe = () => {
  return request.get({
    baseUrl:'m2i',
    url: `auth/user/myself`
  })
}

// 获取当前登录账号的org信息
export const getOrgMe = () => {
  return request.get({
    url: `/m2i/auth/user/orgs`  
  })
}

// 切换租户
export const SwtichOrg = (org_id) => {
  return request.put({
    url: `${AUTH_PREFIX}/switchorg`,
    data: {org_id:org_id}
  })
}

export const getAccount = (orgId, data) => {
  return request.post({
    url: `${AUTH_PREFIX}${ACCOUNT}/list`,
    data,
    headers: {
      'org-id': orgId
    }
  })
}
// export const getAccountAll = (orgId, data) => {
//   return request.post({
//     url: `${AUTH_PREFIX}${ACCOUNT}/list`,
//     data
//   })
// }

// // 创建用户。添加account到多org下，可以不绑定角色
// export const createAccount = (data) => {
//   return request.post({
//     url: `${AUTH_PREFIX}${ACCOUNT}/crossorg`,
//     data
//   })
// }

// // 更新用户。添加account到多org下，可以不绑定角色
// export const updateAccount = (data) => {
//   return request.put({
//     url: `${AUTH_PREFIX}${ACCOUNT}/crossorg`,
//     data
//   })
// }

// // 查询用户详细信息
// export const getAccountById = (id) => {
//   return request.get({
//     url: `${AUTH_PREFIX}${ACCOUNT}/crossorg/byid?id=${id}`
//   })
// }

// // 批量删除用户
// export const deleteAccountList = (orgId, ids) => {
//   return request.delete({
//     url: `${AUTH_PREFIX}${ACCOUNT}/list`,
//     data: { ids: ids },
//     headers: {
//       'org-id': orgId
//     }
//   })
// }
// // 批量修改用户状态
// export const changeAccountStatus = (orgId, data) => {
//   return request.put({
//     url: `${AUTH_PREFIX}${ACCOUNT}/list/status`,
//     data,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const resetPassword = (data) => {
//   return request.put({
//     url: `${AUTH_PREFIX}/changepwd`,
//     data
//   })
// }


// // 查询绑定或者没有绑定某些角色的账户列表
// export const getAccountByRole = (orgId, role, userName, index, count, isBindRole) => {
//   return request.get({
//     url: `${AUTH_PREFIX}${ACCOUNT}/single/byrole?roleName=${role}&userName=${userName}&index=${index}&count=${count}&bindRole=${isBindRole}`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// // 批量绑定用户
// export const bindRoleList = (orgId, data) => {
//   return request.put({
//     url: `${AUTH_PREFIX}${ACCOUNT}/list/bindrole`,
//     data,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// // 批量解绑用户
// export const unbindRoleList = (orgId, data) => {
//   return request.put({
//     url: `${AUTH_PREFIX}${ACCOUNT}/list/unbindrole`,
//     data,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const getRoleList = (orgId, name, index, count) => {
//   return request.get({
//     url: `${AUTH_PREFIX}${ROLE}?name=${name}&index=${index}&count=${count}`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const getRoleById = (orgId, roleId) => {
//   return request.get({
//     url: `${AUTH_PREFIX}${ROLE}/byid?id=${roleId}`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const deleteRoleById = (orgId, roleId) => {
//   return request.delete({
//     url: `${AUTH_PREFIX}${ROLE}?id=${roleId}`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const addRole = (orgId, data) => {
//   return request.post({
//     url: `${AUTH_PREFIX}${ROLE}`,
//     data,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const updateRole = (orgId, data) => {
//   return request.put({
//     url: `${AUTH_PREFIX}${ROLE}`,
//     data,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const deleteRole = (orgId, data) => {
//   return request.delete({
//     url: `${AUTH_PREFIX}${ROLE}/list`,
//     data,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// //  获取org下的服务
// export const getOrgService = (orgId) => {
//   return request.get({
//     url: `${AUTH_PREFIX}${SERVICE}`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }
// // 查询该组织某一服务的资源类别
// export const getResourceType = (orgId, service) => {
//   return request.get({
//     url: `${AUTH_PREFIX}${RESOURCE}/type?service=${service}`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }
// // 获取服务下的资源
// export const getResource = (orgId, service, type, index, count, group?, name?) => {
//   let url = `${AUTH_PREFIX}${RESOURCE}?service=${service}&type=${type}&index=${index}&count=${count}`
//   if (group) {
//     url = url + `&group=${group}`
//   }
//   if (name) {
//     url = url + `&name=${name}`
//   }
//   return request.get({
//     url: url,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// // 获取多group下资源
// export const getResourceByGroup = (orgId, data) => {
//   return request.post({
//     url: `${AUTH_PREFIX}${RESOURCE}/bygroups`,
//     data,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const getResourceByGroup = (orgId, data) => {
//   let groups = ''
//   data.groups.forEach((item) => {
//     console.log('item: ', item)
//     groups = groups + '&group=' + item
//   })
//   return request.get({
//     url: `${AUTH_PREFIX}${RESOURCE}?service=${data.service}&type=${data.type}${groups}&index=${data.index}&count=${data.count}`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const deleteResource = (orgId, id) => {
//   return request.delete({
//     url: `${AUTH_PREFIX}${RESOURCE}?id=${id}`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const addResource = (data) => {
//   return request.post({
//     url: `${AUTH_PREFIX}${RESOURCE}`,
//     data
//   })
// }

// export const updateResource = (data) => {
//   return request.put({
//     url: `${AUTH_PREFIX}${RESOURCE}`,
//     data
//   })
// }

// export const getSaaSOrg = () => {
//   return request.get({
//     url: `saas-composer/api/org`
//   })
// }

// export const getSaaSPath = (orgId) => {
//   return request.get({
//     url: `saas-composer/api/sketchboard?org_id=${orgId}`
//   })
// }

// export const getDashFolder = (id) => {
//   return request.get({
//     url: `dashboard/api/search?folderIds=${id}`
//   })
// }

// export const getAllProject = (orgId) => {
//   return request.get({
//     url: `/api-apm/api/v1/project?index=0&count=1000`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// export const getgroupsByProject = (orgId, projectId) => {
//   return request.get({
//     url: `/api-apm/api/v1/project/groups?id=${projectId}&index=0&count=1000`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// // 获取资产组使用的模板
// export const getTempByGroup = (orgId, groupId) => {
//   return request.get({
//     url: `/api-apm/api/v1/template/bygroup?groupId=${groupId}&withOutImage=true`,
//     headers: {
//       'org-id': orgId
//     }
//   })
// }

// // S3：测试连接
// export const testConnect = (data) => {
//   // return request.post({ url: '/iems/v1/simplejson/query/v1', data, headers: { orgid: 'ibms' } })
//   return request.get({
//     url: `/iems/v1/s3/testhttps?minioService=${data.minioService}&minioAccessKey=${data.minioAccessKey}&minioSecretKey=${data.minioSecretKey}`
//   })
// }

// // S3：测试连接http
// export const testConnectHttp = (data) => {
//   // return request.post({ url: '/iems/v1/simplejson/query/v1', data, headers: { orgid: 'ibms' } })
//   return request.get({
//     url: `/iems/v1/s3/testhttp?minioService=${data.minioService}&minioAccessKey=${data.minioAccessKey}&minioSecretKey=${data.minioSecretKey}`
//   })
// }

// // S3：保存
// export const s3Save = (data) => {
//   // return request.post({ url: '/iems/v1/simplejson/query/v1', data, headers: { orgid: 'ibms' } })
//   return request.post({
//     url: `/iems/v1/set/variables`,
//     data
//   })
// }

// // S3：创建minio实例
// export const s3CreateInstance = (data) => {
//   // return request.post({ url: '/iems/v1/simplejson/query/v1', data, headers: { orgid: 'ibms' } })
//   return request.get({
//     url: `/iems/v1/s3/create?minioService=${data.minioService}&minioAccessKey=${data.minioAccessKey}&minioSecretKey=${data.minioSecretKey}`
//   })
// }

// // S3：获取账密
// export const s3GetInfo = () => {
//   // return request.post({ url: '/iems/v1/simplejson/query/v1', data, headers: { orgid: 'ibms' } })
//   return request.post({
//     url: `/iems/v1/custom/variables`,
//     data: {
//       keys: ['minioService', 'minioAccessKey', 'minioSecretKey']
//     }
//   })
// }

// // 能源介质管理：获取分类分项数据
// export const getSubitemApi = (options) => {
//   return request.get({
//     url: `/iems/v1/resources/newsubitems?language=${options['language']}&apmOrgId=${options['apmOrgId']}`
//   })
// }

// // 能源介质管理：新增分类分项
// export const addSubitem = (data) => {
//   return request.post({
//     url: `/iems/v1/resource`,
//     data
//   })
// }

// // 能源介质管理：修改分类分项
// export const editSubitem = (id, data) => {
//   return request.put({
//     url: `/iems/v1/resources/${id}`,
//     data
//   })
// }

// // 能源介质管理：删除分类分项
// export const deleteSubitem = (data) => {
//   return request.delete({
//     url: `/iems/v1/resources`,
//     data
//   })
// }

// // 能源介质管理：获取转换系数
// export const getCoefficient = ({ subitem_code, apmOrgId }) => {
//   return request.get({
//     url: `/iems/v1/coefficients?subitem_code=${subitem_code}&apmOrgId=${apmOrgId}`
//   })
// }

// // 能源介质管理：获取父级转换系数
// export const getParentCoefficient = (data) => {
//   return request.post({
//     url: `/iems/v1/coefficients`,
//     data
//   })
// }

// // 能源介质管理：新增转换系数
// export const addCoefficient = (data) => {
//   return request.post({
//     url: `/iems/v1/coefficient`,
//     data
//   })
// }

// // 能源介质管理：删除转换系数
// export const deleteCoefficient = (id) => {
//   return request.delete({
//     url: `/iems/v1/coefficient`,
//     data: { id }
//   })
// }

// // 能源介质管理：编辑转换系数
// export const editCoefficient = (id, data) => {
//   return request.put({
//     url: `/iems/v1/coefficients/${id}`,
//     data
//   })
// }

// // 第三方接口列表 /interface
// export const getInterface = (orgId) => {
//   return request.get({
//     url: `/iems/v1/interface?orgId=${orgId}`
//   })
// }

// // 第三方接口测试链接
// export const getInterfaceTest = (data) => {
//   return request.post({
//     url: `/iems/v1/interface/test/connect`,
//     data
//   })
// }

// // 第三方接口添加接口
// export const addInterface = (data) => {
//   return request.post({
//     url: `/iems/v1/interface`,
//     data
//   })
// }

// // 第三方接口编辑
// export const editInterface = (data) => {
//   return request.put({
//     url: `/iems/v1/interface`,
//     data
//   })
// }

// // 第三方接口删除
// export const deleteInterface = (data) => {
//   return request.delete({
//     url: `/iems/v1/interface`,
//     data
//   })
// }
